import React from "react";
import CashierFraud from "./CashierFraudUpdated.tsx"
import "./CashierFraud.css"

const CashierFraudPage: React.FC = () => {
    
    return (
        <div className="cashier-page-container">
           <CashierFraud />
        </div>
    )
}

export default CashierFraudPage;
